import React, {useState, useContext} from 'react';
import {withStyles} from '@material-ui/core';
import Filter from './Filter'
import Grid from '@material-ui/core/Grid';
import {Loader, TablePagination} from '../../components';
import {apvgkService} from "../../services/apvgkService";
import PhotoModal from "../admin/track/PhotoModal";
import moment from "moment";

const styles = () => ({});


const ApvgkMonitorPage = () => {
    const [filter, setFilter] = useState({
        apvgk_id: null,
        order_rule: 'desc',
        base64: 1,
        per_page: 9,
        min_date: moment(new Date(new Date().setHours(0,0))).format('YYYY-MM-DD HH:mm')
    });
    const [items, setItems] = useState({
        data: [],
        per_page: filter.per_page,
        current_page: 1,
    });
    const fetchPage = async (filt) => {
        let f = {...filter, ...filt};
        setFilter(f);
        try {
            const response = await apvgkService.getTrackDataPage(f);
            setItems(response);
        } catch (e) {
            setItems({...items, ...{data: []}});
            console.log(e);
        }
    }
    React.useEffect(() => {
        fetchPage(filter)
    }, [])
    return (
        <>
            <main role="main" className="container text-center">
                <Grid
                    container
                    role="main"
                    className="container text-left"
                    direction="column"
                    spacing={16}
                    wrap="nowrap"
                >
                    <Grid item>
                        <Grid container direction="column" spacing={16}>
                            <br/>
                            <Grid container direction="row" spacing={16}>
                                <Grid item xs={12}>
                                    <h2 >Проезды с нераспознанными ГРЗ</h2>
                                </Grid>
                                <Grid item xs={12}>
                                    <Filter currentFilters={filter} onFiltersChange={fetchPage}/>
                                </Grid>
                            </Grid>
                            <br/>
                        </Grid>
                    </Grid>
                </Grid>
                {!items.data ? <Loader/> : <Grid container direction="row" spacing={16}>
                    {items.data.map(v => {
                        let file = v.file && v.file || '';
                        return (
                            <Grid item xs={12} md={4}  key={v.id}>
                                <Grid container direction="column" justify="space-between">
                                    <Grid>
                                        <b> Проезд номер {v.id} от {v.ExcessFactDate}</b>
                                    </Grid>
                                    {file &&
                                        <img
                                            style={{ flex: 1, minWidth:"100%",maxWidth:"100%"}}
                                            src={file.indexOf('http') === 0 ? file : `data:image/png;base64,${file}`}
                                        /> || ''}
                                    <Grid><PhotoModal id={v.id} label="Все фотографии"/></Grid>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>}
                <TablePagination
                    meta={items}
                    onChangePage={page => {
                        fetchPage({...filter, page,});
                    }}
                />
            </main>
        </>
    );
};

export default withStyles(styles)(ApvgkMonitorPage);
